import { connect } from "react-redux";
import AddGate from "./addGate";
import { bindActionCreators } from "redux";
import {
  gateTypeList,
  fetchLeadGate,
  addCorporateGate,
  addApartmentGate,
} from "services/redux/sales/gates/action";

const mapStateToProps = (state) => ({
  typeList: state.gateReducer.typeList,
  leadGates: state.gateReducer.leadGates,
  gateData: state.gateReducer.gateData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      gateTypeList,
      fetchLeadGate,
      addCorporateGate,
      addApartmentGate,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AddGate);
